'use client';
import React from 'react';
import { X, Droplets } from 'lucide-react';

interface ClimateRecommendationProps {
  lang: 'en' | 'ta';
  onDismiss: () => void;
}

export default function ClimateRecommendation({ lang, onDismiss }: ClimateRecommendationProps) {
  return (
    <div className="climate-card-gradient climate-animate rounded-4xl p-6 md:p-8 relative overflow-hidden border border-blue-100">
      {/* Decorative water drops */}
      <div className="absolute top-4 right-16 opacity-20">
        <Droplets size={48} className="text-blue-400" />
      </div>
      <div className="absolute bottom-4 right-8 opacity-10">
        <Droplets size={32} className="text-blue-300" />
      </div>

      <button
        onClick={onDismiss}
        className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center rounded-xl bg-white/60 hover:bg-white/80 text-muted-foreground transition-all active:scale-95"
        aria-label="Dismiss climate recommendation"
      >
        <X size={16} />
      </button>

      <div className="flex items-start gap-5">
        <div className="float-animation text-5xl flex-shrink-0" aria-hidden="true">🥒</div>
        <div>
          <p className="section-label text-blue-600 mb-2">
            {lang === 'en' ? "Today's Climate Recommendation" : 'இன்றைய வானிலை பரிந்துரை'}
          </p>
          <h3 className="text-xl font-bold text-foreground mb-2">
            {lang === 'en' ? 'Cucumber — Your Summer Shield' : 'வெள்ளரிக்காய் — உங்கள் கோடை கவசம்'}
          </h3>
          <p className="text-sm text-muted-foreground leading-relaxed max-w-lg">
            {lang === 'en' ? "Chennai is 36°C today. Cucumber's 96% water content keeps you hydrated and cool. At just ₹27/kg — down ₹8 this week — it's the smartest buy of the day." :'சென்னையில் இன்று 36°C. வெள்ளரிக்காயின் 96% நீர் உள்ளடக்கம் உங்களை குளிர்ச்சியாக வைக்கும். வெறும் ₹27/கிலோ — இந்த வாரம் ₹8 குறைந்தது — இன்றைய சிறந்த கொள்முதல்.'}
          </p>
          <div className="flex items-center gap-4 mt-4">
            <div className="flex items-center gap-2">
              <span className="text-2xl font-bold text-primary font-tabular">₹27</span>
              <span className="text-sm text-muted-foreground">/kg today</span>
            </div>
            <span className="text-xs font-semibold text-drop-green bg-green-light rounded-full px-3 py-1">
              ↓ ₹8 this week
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}